import moment from 'moment'

export default {
  minutesAgo: (minutes) => moment().subtract(minutes, 'minutes'),

  hoursAgo: (hours) => moment().subtract(hours, 'hours'),

  utcDate: moment.utc().format('YYYY-MM-DD'),

  momentToFormattedDate: (time, format = 'YYYY-MM-DD') =>
    moment(time).format(format).toString(),

  getCurrentDateTimeString: () => moment().format('YYYYMMDDHHmmSS'),

  convertSecondsToHumanTime: (s) => {
    const ms = s % 1000
    s = (s - ms) / 1000
    const secs = s % 60
    s = (s - secs) / 60
    const mins = s % 60
    const hrs = (s - mins) / 60
    return {
      hours: hrs,
      minutes: mins,
      seconds: secs,
      formatted: hrs + 'h:' + mins + 'm:' + secs + 's'
    }
  },

  getTimestampRangeForLastHours: (hours) => {
    const currentTime = new Date()
    const startTimeMilliseconds = currentTime.getTime() - hours * 1000 * 60 * 60
    const startTime = new Date(startTimeMilliseconds)

    return {
      startTime: startTime.toISOString(),
      endTime: currentTime.toISOString()
    }
  }
}
